import { render } from "./transbankValidator.vue?vue&type=template&id=60deaa2b&ts=true"
import script from "./transbankValidator.vue?vue&type=script&lang=ts"
export * from "./transbankValidator.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__